/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { UserFurtherEducationList, IUserFurtherEducationListOwnProps, IUserFurtherEducationListStateProps, IUserFurtherEducationListDispatchProps } from "../../components/userFurtherEducation/userFurtherEducationList";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IUserFurtherEducationListOwnProps): IUserFurtherEducationListStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.task) || Base.isNullOrUndefined(applicationState.task.taskList)) {
        return {
            user: null,
            hasMore: true,
            isLoading: false,
            page: 0,
            archived: false,
            items: [],
            qualifications: [],
            sortColumn: "",
            lastOpenedUserFurtherEducationId: "",
        };
    }
    const list = applicationState.userFurtherEducation.userFurtherEducationList;
    return {
        user: applicationState.user,
        hasMore: list.hasMore,
        isLoading: list.isLoading,
        page: list.page,
        archived: list.archived,
        items: list.items,
        qualifications: list.qualifications,
        sortColumn: list.sortColumn,
        lastOpenedUserFurtherEducationId: list.lastOpenedUserFurtherEducationId,
    };
}

export function mapDispatchToProps(dispatch: storeEffects.UserFurtherEducationThunkDispatch): IUserFurtherEducationListDispatchProps {
    return {
        loadUserFurtherEducations: (page: number, archived: boolean) => dispatch(storeEffects.getUserFurtherEducationList(page, archived)),
        removeUserFurtherEducation: (id: string) => dispatch(storeActions.userFurtherEducationListRemove(id)),
        resetUserFurtherEducations: () => dispatch(storeActions.userFurtherEducationListReset()),
        refreshUserFurtherEducations: (page: number, archived: boolean) => dispatch(storeEffects.userFurtherEducationListRefresh(page, archived)),
        setLastOpenedUserFurtherEducationId: (id: string) => dispatch(storeActions.userFurtherEducationListSetLastOpened(id)),
        setReturnUrl: (url: string) => dispatch(storeActions.userFurtherEducationEditSetReturnUrl(url)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<IUserFurtherEducationListStateProps, IUserFurtherEducationListDispatchProps, IUserFurtherEducationListOwnProps>(mapStateToProps, mapDispatchToProps)(UserFurtherEducationList);